module.exports = __webpack_public_path__ + "img/logo-ytrack-light.28526f9f.svg";